/**
 * Цвет огня — по длине стрика, а не по тому, сколько позанимался сегодня.
 * Ступени растут всё реже (1, 10, 30, 60, 100, 180, 365 дней): первые
 * смены цвета приходят быстро и цепляют, дальше каждая — событие.
 * Цвета — по «температуре» пламени: оранжевый → красный → малиновый →
 * фиолетовый → синий → ледяной, год — золото.
 */
export type StreakTier = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

/** Порог в днях для ступеней 1…7 — индекс = ступень − 1. */
export const STREAK_TIER_DAYS = [1, 10, 30, 60, 100, 180, 365] as const;

export function streakTier(days: number): StreakTier {
  let tier = 0;
  for (const threshold of STREAK_TIER_DAYS) if (days >= threshold) tier++;
  return tier as StreakTier;
}

/**
 * Какой огонь показать: пока сегодня цель не выполнена — серый (стрик ещё
 * держится со вчера, но «сегодня» не засчитано, это и есть напоминание),
 * после — цвет ступени стрика.
 */
export function flameTier(streak: number, todaySeconds: number, goalMinutes: number): StreakTier {
  return todaySeconds >= goalMinutes * 60 ? streakTier(streak) : 0;
}
